<template>
  <div>
    <div class="fourthSectionContainer" v-if="this.langChosen === 'gr'">
      <div class="fourthSectionPart">
        <div class="fourSectionTitle">ข้อมูลทั่วไป</div>
        <ul>
          <li>สมัครโบนัส</li>
          <li>เกมคาสิโน</li>
          <li>รายชื่อซัพพลายเออร์</li>
          <li>คำถามที่พบบ่อย</li>
          <li>เกี่ยวกับเรา</li>
          <li>ดาวน์โหลดและเล่นเลย</li>
        </ul>
      </div>

      <div class="fourthSectionPart">
        <div class="fourSectionTitle">ข้อมูลเพิ่มเติม</div>

        <ul>
          <li>นโยบายความเป็นส่วนตัว</li>
          <li>การเล่นเกมอย่างมีความรับผิดชอบ</li>
          <li>การเล่นที่ยุติธรรม</li>
          <li>ข้อกำหนดและเงื่อนไข</li>
          <li>โปรแกรมพันธมิตรคาสิโน</li>
        </ul>
      </div>
    </div>

    <div class="fourthSectionContainer" v-else>
      <div class="fourthSectionPart">
        <div class="fourthSectionTitle">General information</div>

        <ul>
          <li>Bonus Registration</li>
          <li>Casino games</li>
          <li>List of suppliers</li>
          <li>Frequent questions</li>
          <li>About us</li>
          <li>Download and play now</li>
        </ul>
      </div>

      <div class="fourthSectionPart">
        <div class="fourthSectionTitle">More information</div>

        <ul>
          <li>Privacy Policy</li>
          <li>Responsible game</li>
          <li>Fair play</li>
          <li>Terms and conditions</li>
          <li>Casino affiliate program</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.fourthSectionContainer {
  background-color: var(--lightColor);
  color: var(--darkColor);
  padding: 30px;
  padding-bottom: 1px;
}

.fourthSectionTitle {
  font-weight: bold;
}

ul,
ul li {
  margin-top: 7px;
}

.fourthSectionPart {
  margin-bottom: 30px;
}

@media screen and (min-width: 768px) {
  .fourthSectionContainer {
    display: flex;
    justify-content: space-evenly;
  }
}
</style>
